"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AllRestoreStrategyBuilder_1 = require("./AllRestoreStrategyBuilder");
var MessageIdRestoreStrategyBuilder_1 = require("./MessageIdRestoreStrategyBuilder");
var TimestampRestoreStrategyBuilder_1 = require("./TimestampRestoreStrategyBuilder");
var RestoreStrategyBuilderFactory = /** @class */ (function () {
    function RestoreStrategyBuilderFactory() {
    }
    RestoreStrategyBuilderFactory.all = function () {
        return new AllRestoreStrategyBuilder_1.default();
    };
    RestoreStrategyBuilderFactory.messageId = function () {
        return new MessageIdRestoreStrategyBuilder_1.default();
    };
    RestoreStrategyBuilderFactory.timestamp = function () {
        return new TimestampRestoreStrategyBuilder_1.default();
    };
    return RestoreStrategyBuilderFactory;
}());
exports.default = RestoreStrategyBuilderFactory;
//# sourceMappingURL=RestoreStrategyBuilderFactory.js.map